
/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { validate as validateUuid } from 'uuid';
import is from '../../is';

/**
 * Extracts data like an MS Teams Channel ID and Azure Tenant ID from a MS Teams Channel URL
 *
 * @param {String} channelDataOrUrl The user input, which could be a chanel URL copied from MS Teams, or anything else
 * @returns {Object} The extracted data (channelId, azureTenantId)
 */
const extractMsTeamsDataFromUrl = (channelDataOrUrl) => {
  // Return if URL is empty
  if (!channelDataOrUrl) {
    return Promise.reject({
      channelId: 'Please enter a value.',
      azureTenantId: 'Please enter a value.',
      aadGroupId: 'Please enter a value.'
    });
  }

  let msTeamsData = {};

  try {
    // In case of URL
    const channelUrl = new URL(channelDataOrUrl);

    // Export Channel ID
    const channelId = channelUrl.pathname.split('/')[3];
    if (channelId && channelId.includes('thread.tacv2')) {
      msTeamsData.channelId = decodeURIComponent(channelId);
    }

    // Export Azure Tenant ID and other data
    const azureTenantId = channelUrl.searchParams.get('tenantId');
    if (azureTenantId) {
      msTeamsData.azureTenantId = azureTenantId;
    }

    // Export Azure Active Directory ID and other data
    const aadGroupId = channelUrl.searchParams.get('groupId');
    if (aadGroupId) {
      msTeamsData.aadGroupId = aadGroupId;
    }

    if (is.emptyObject(msTeamsData)) {
      return Promise.reject({
        channelId: 'Please enter a correct format.',
        azureTenantId: 'Please enter a correct format.',
        aadGroupId: 'Please enter a correct format.'
      });
    } else {
      return Promise.resolve(msTeamsData);
    }
  } catch (_) {
    // In case of Azure Tenant ID (a UUID)
    if (validateUuid(channelDataOrUrl)) {
      msTeamsData.azureTenantId = channelDataOrUrl;
      return Promise.resolve(msTeamsData);
    }

    // In case of Channel ID
    if (channelDataOrUrl.includes('thread.tacv2') && !channelDataOrUrl.includes('http')) {
      msTeamsData.channelId = decodeURIComponent(channelDataOrUrl);
      return Promise.resolve(msTeamsData);
    }

    // Else (invalid input)
    return Promise.reject({
      channelId: 'Please enter a correct format.',
      azureTenantId: 'Please enter a correct format.',
      aadGroupId: 'Please enter a correct format.'
    });
  }
};

export default extractMsTeamsDataFromUrl;
